var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationSeverityUrgentRed = function SvgNotificationSeverityUrgentRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD3838",
    strokeLinecap: "round",
    d: "M10 7.292v3.333m0 2.292v-.009m.208.009a.208.208 0 1 1-.416 0 .208.208 0 0 1 .416 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD3838",
    strokeLinecap: "square",
    d: "M2.33 13.523 8.569 3.034a1.667 1.667 0 0 1 2.865 0l6.236 10.489c.66 1.111-.14 2.518-1.432 2.518H3.763c-1.292 0-2.093-1.407-1.432-2.518Z"
  })));
};
export { SvgNotificationSeverityUrgentRed as ReactComponent };
export default __webpack_public_path__ + "4835b7e2b4d377f95886992a12fb582c.svg";